import type { ReactNode } from 'react';
import { memo } from 'react';
import { styled } from '@mui/material/styles';

const AIGradientIconWrapper = styled('div')({
  display: 'inline-flex',
  position: 'relative',
});

type GradientIconProps = {
  icon: (gradientId: string) => ReactNode;
};

export const AIGradientIcon = memo(function AIGradientIcon({ icon }: GradientIconProps) {
  const gradientId = 'ai-icon-gradient';

  return (
    <AIGradientIconWrapper>
      <svg width="0" height="0">
        <defs>
          <linearGradient id={gradientId} x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="8.03%" stopColor="#B163BB" />
            <stop offset="47.18%" stopColor="#786ABC" />
            <stop offset="79.05%" stopColor="#00658C" />
          </linearGradient>
        </defs>
      </svg>
      {icon(gradientId)}
    </AIGradientIconWrapper>
  );
});
